
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private afAuth: AngularFireAuth,
  ) {}

  public checkAuthState() {
    var that = this;
    this.afAuth.onAuthStateChanged(function (user) {
      if (user) {
        console.log('logged in', user);
      } else {
      }
    });
  }

  registerUser(value) {
    return new Promise<any>((resolve, reject) => {
      this.afAuth
        .createUserWithEmailAndPassword(value.email, value.password)
        .then(
          (res) => resolve(res),
          (err) => reject(err)
        );
    });
  }

  loginUser(value) {
    return new Promise<any>((resolve, reject) => {
      this.afAuth.signInWithEmailAndPassword(value.email, value.password).then(
        (res) => resolve(res),
        (err) => reject(err)
      );
    });
  }

  logoutUser() {
    return new Promise((resolve, reject) => {
      if (this.afAuth.currentUser) {
        this.afAuth
          .signOut()
          .then(() => {
            console.log('LOG Out');
          })
          .catch((error) => {
            reject(error);
          });
      }
    });
  }

  forgotPassword(email) {
    return new Promise((resolve, reject) => {
      this.afAuth.sendPasswordResetEmail(email).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  userDetails() {
    return this.afAuth.user;
  }
}
